import { Action, createReducer, on } from '@ngrx/store';
import * as MessageHubActions from '../state/actions/message-hub.actions';

export interface MessageHubState {
    isConnectionStarted: boolean;
    isReconnected: boolean;
}

const initialMessageHubState: MessageHubState = {
    isConnectionStarted: false,
    isReconnected: false
};

const reducer = createReducer<MessageHubState>(
    initialMessageHubState,
    on(MessageHubActions.messageHubConnectionStarted, (mesageHubState): MessageHubState => (
        {
            ...mesageHubState,
            isConnectionStarted: true
        }
    )),
    on(MessageHubActions.messageHubConnectionReStarted, (mesageHubState): MessageHubState => (
        {
            ...mesageHubState,
            isReconnected: true
        }
    )),
);

export function messageHubReducer(state: MessageHubState | undefined, action: Action) {
    return reducer(state, action);
}
